'use strict';

var $ = require('jquery');
var basePageNoAdsNoComponents = require('../pages/base-page-noAds-noComponents.js');

var classNames = {
	choosePackage: 'choose-package',
	packageSelect: 'package-select',
	purchaseForm: 'purchase-form',
	loginForm: 'login-form',
	select: 'select',
	moreIndicator: 'more-indicator'
};

var $loginForm, $purchaseForm;

function addEmailValidation () {
	$.validator.addMethod(
		'regex',
		function (value, element, regexp) {
			return regexp.test(value);
		}
	);
}

function initValidation() {
	// 'perfect' email regex doesn't exist but we need to use one that will pass Stripe's own checks.
	// xx@xx will get thrown back, whilst xx@xx.xx will pass.
	var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	addEmailValidation();

	$loginForm.validate({
		rules: {
			Email: { required: true },
			Password: { required: true }
		},
		messages: {
			Email: 'Enter your email address',
			Password: 'Enter your password'
		},
		errorPlacement: function (error, $element) {
			error.insertAfter($element);
			error.addClass('alert-box alert');
			error.addBemClass(classNames.choosePackage, 'validation-error');
		},
		focusInvalid: false
	});

	$purchaseForm.validate({
		rules: {
			SelectedId: { required: true },
			Email: { 
				required: true,
				email: true,
				regex: emailRegex
			},
			Password: { required: true }
		},
		messages: {
			SelectedId: 'Select the period of access you require',
			Email: { 
				required: 'Please enter an email address',
				regex: 'Please enter a valid email address'
			},
			Password: 'Please enter a password'
		},
		errorPlacement: function (error, $element) {
			if ($element.is(':radio')) {
				// package selection
				// place error after the select container.
				var selectList = $.findByBem(classNames.packageSelect);
				error.insertAfter(selectList);
			} else { 
				error.insertAfter($element);
			}

			error.addClass('alert-box alert');
			error.addBemClass(classNames.choosePackage, 'validation-error');
		},
		focusInvalid: false
	});
}

function toggleShowPassword() {
	var $password = $.findByBem(classNames.choosePackage, 'password');
	var $passwordToggle = $.findByBem(classNames.choosePackage, 'show-password');

	$passwordToggle.on('click', function() {
		$passwordToggle.toggleClass('fi-lock fi-unlock');
		$password.attr('type', $password.attr('type') === 'text' ? 'password' : 'text');
	});
}

function setPackageSelectScrollIndicator() {
	var $packageSelect = $.findByBem(classNames.packageSelect);
	var $scrollIndicator = $.findByBem(classNames.choosePackage, classNames.moreIndicator);
	var scrollbarPositionNearToEnd = 30;

	$packageSelect.on('scroll', function() {
		var scrollTotalWidth = this.scrollWidth - this.offsetWidth;

		// If the scroll bar is nearing its end then hide the 'there's more' indicator.
		if ((scrollTotalWidth - this.scrollLeft) < scrollbarPositionNearToEnd) {
			$scrollIndicator.addClass('hide');
		} else {
			$scrollIndicator.removeClass('hide');
		}
	});
}

function setControls() {
	$loginForm = $.findByBem(classNames.loginForm);
	$purchaseForm = $.findByBem(classNames.purchaseForm);
	
	toggleShowPassword();
	setPackageSelectScrollIndicator();
	initValidation();
}

basePageNoAdsNoComponents.init = function() {
	basePageNoAdsNoComponents.initBasePage();
	setControls();
};

module.exports = basePageNoAdsNoComponents;